module.exports = __webpack_public_path__ + "img/4.d41a651a.jpg";